export default "__VITE_ASSET__BStz0KT1__"